// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.RentalManagerUserPropertyActivateV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyActivateResponseV2WebDto, UserPropertyActivateV2RequestDto } from '../..';

export const RentalManagerUserPropertyActivateV2WebApiHandler_activate_Path = '/api/web/v2/users/properties/activate';

/**
 * Activate a property
 */
export const RentalManagerUserPropertyActivateV2WebApiHandler_activate = (
  postData: UserPropertyActivateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyActivateV2RequestDto, UserPropertyActivateResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyActivateV2WebApiHandler_activate_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
